export default __webpack_public_path__ + "static/cercle_vicieux_uw_en-67b0d39a5cb45c68c031d227d76b22e9.mp4";